import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { getDataSession } from 'views/Utils/Common';
import { MenuDescargas } from '../../Movimiento/MenuDescargas';
import { Link } from 'react-router-dom';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';

const List = ({ history, match }) => {
    const { path } = match;
    const { t } = useTranslation("common");
    const [actualizarTabla,] = useState(false);
    const { changeGlobalTitle } = useUIUtils()

    const [dataMenu] = useState([{
        Titulo: 'Listado de Planes de Visita',
        Data: [
            { Titulo: 'Descargar Excel', Slug: 'EXCEL' },
            { Titulo: 'Descargar PDF', Slug: 'PDF' }
        ]
    },
    {
        Titulo: 'Plan de Visita',
        Data: [
            { Titulo: 'Descargar Excel', Slug: 'EXCEL' },
            { Titulo: 'Descargar PDF', Slug: 'PDF' }
        ]
    }]);
    const columns = [
        { renderCell: RenderButtons, type: 'actions', headerName: '', maxWidth: 20, path: path, opciones: "editar" },
        { field: 'fecha_Inicial', headerName: 'Inicial', minWidth: 150, renderCell: ({ value }) => value?.substring(0, 10) },
        { field: 'fecha_Final', headerName: 'Final', minWidth: 150, renderCell: ({ value }) => value?.substring(0, 10) },
        { field: 'nombre_Agente', headerName: 'Agente', minWidth: 250 },
        { field: 'nombre', headerName: 'Nombre', minWidth: 250 }
    ];

    const onClickButtonMenu = (slug) => { }

    useEffect(() => changeGlobalTitle('Planes de Visita', 'Listado de Planes de Visita'), [changeGlobalTitle]);

    return (<>
        <MenuDescargas data={dataMenu} onClickButton={onClickButtonMenu} />
        <div className='espacio10px' />
        <div className='container-fluid'>
            <div className='col-12 col-sm-12 col-md-12 row'>
                <div className='col-sm-2'>
                    <Link to={`${path}/add`} className='btn btn-outline-primary m-1' style={{ width: 'auto' }}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            fill='currentColor'
                            className='bi bi-plus-square'
                            viewBox='0 0 16 16'
                        >
                            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                        </svg>
                        &nbsp; {t('app.SwalFire.nuevo')}
                    </Link>
                </div>
                <div className='col-sm-5' />
                {/*<div className='col-sm-5' style={{ display: 'flex' }}>
                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                            id="filled-number"
                            label="Fecha Inicio"
                            type="date"
                            value={fechaInicio}
                            onChange={handleInputChangeFechaInicio}
                            InputLabelProps={{ shrink: true, }}
                        />
                        <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                            id="filled-number"
                            label="Fecha Fin"
                            type="date"
                            value={fechaFin}
                            onChange={handleInputChangeFechaFin}
                            InputLabelProps={{ shrink: true, }}
                        />
                    </div>*/}
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    reload={actualizarTabla}
                    url={`VxPlanesVisitas/GetList?sucursal_Id=${getDataSession('sucursal')}`} />
            </div>
        </div>
    </>);
}

export { List };